const maxLength = (phoneNumber) => {
  const errorMessages = {
    messages: [
      {
        text: 'Ops! O telefone informado não é válido. Por favor, verifique se você digitou direitinho e tente mais uma vez.',
        type: 'message-long-error-icon'
      }
    ]
  };

  if (phoneNumber < 10 || phoneNumber > 11) throw errorMessages;
};

export const phoneValidator = (phoneNumber) => {
  try {
    maxLength(phoneNumber.length);

    return {status: true, phoneNumber: phoneNumber};
  } catch (error) {
    return {status: false, phoneNumber: '', error};
  }
};
